import {saveAs} from "file-saver";

export const download = (data, filename) => {
    const dataBlob = new Blob([data], {type : ""});
    saveAs(dataBlob,filename);
};


export const getCbdIdVersion = ()=>{
    let cbdIdVer={};
    cbdIdVer.cbdString=localStorage.getItem("cbdIdVer");
    localStorage.removeItem("cbdIdVer");
    return cbdIdVer;
}

export const cbdIdVersion=getCbdIdVersion();


// WEBPACK FOOTER //
// ./src/utils/downloadLogic.js